(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('anomalyExceptionsDao', ["http", function (http) {
        return {
            list: function () {
                return http.get('/api/v1/anomaly_whitelist');
            },
            add: function (data) {
                return http.post('/api/v1/anomaly_whitelist').body(data).run();
            },
            edit: function (data) {
                return http.put('/api/v1/anomaly_whitelist').body(data).run();
            },
            remove: function (data) {
                return http.post('/api/v1/anomaly_whitelist/delete').body(data).run();
            }
        };
    }]);
}());